import { sportsTokenRenewHandler } from "../../C_Sportsbook/Helpers";
import { storeToken } from "../../Common";
const handlers = [
    sportsTokenRenewHandler,
];
export function onTokenRenew(payload) {
    handlers.forEach(handler => {
        handler(payload);
    });
    storeToken(payload.data[0].token);
}
//# sourceMappingURL=OnTokenRenew.js.map